import { render, staticRenderFns } from "./Consumption.vue?vue&type=template&id=d96438e0"
import script from "./Consumption.vue?vue&type=script&lang=js"
export * from "./Consumption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports